import * as React from 'react';
import './simplebar.less';
import styles from './index.less';
import * as AHooks from 'ahooks';
import SimpleBar from 'simplebar';

interface FSimpleBarProps {
  children: React.ReactNode;
  width?: number | string;
  height?: number | string;
  id?: string;
  minHeight?: number | string;
  maxHeight?: number | string;
  className?: string;

  onMount?(simpleBar: SimpleBar): void;
}

function FSimpleBar({
  children,
  width = '100%',
  height = '100%',
  id,
  onMount,
  minHeight,
  maxHeight,
  className,
}: FSimpleBarProps) {
  const ref = React.useRef<HTMLDivElement>(null);
  const ref_SimpleBar = React.useRef<SimpleBar>(null);

  AHooks.useMount(() => {
    const simpleBar = new SimpleBar(ref.current as HTMLDivElement, {
      autoHide: true,
    });
    // @ts-ignore
    ref_SimpleBar.current = simpleBar;
    onMount?.(simpleBar);
  });

  return (
    <div
      id={id}
      style={{
        width,
        height,
        minHeight,
        maxHeight,
        overscrollBehavior: 'contain',
      }}
      ref={ref}
      className={className}
    >
      {children}
    </div>
  );
}

export default FSimpleBar;
